export const permissionsUrl = 'permissions/';
